// @flow
import * as React from 'react';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { Stack, Typography } from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import { menuCollapsed } from '../../app/ui/menu-toggle-button';
import { useState } from 'react';
import { SearchAnythingModal } from './search-anything-modal';

export const SearchAnythingButton = () => {
  const collapsed = useReactiveVar(menuCollapsed);
  const [open, setOpen] = useState(false);
  return (
    <>
      <Stack sx={{
        cursor: 'pointer',
        p: 1, '&:hover': {bgcolor: '#e9f2f5', '& p': {fontWeight: 600} }, borderRadius: '8px',
      }} direction={'row'} alignItems={'center'} onClick={() => setOpen(true)}>
        <MagnifyingGlass size={18} color="#1c434f" style={{minWidth: 18}} />

        <Typography sx={{ display: 'inline-flex', ml: 1, opacity: collapsed ? 0 : 1, transition: 'opacity .5s ' }}
                    variant={'body2'}
                    color={'#1c434f'}
                    noWrap>Search</Typography>
      </Stack>
      <SearchAnythingModal open={open} onClose={() => {setOpen(false)}} />
    </>
  );
};
